import { request } from './request';

/**
 * Get all API keys for the authenticated user
 * @returns {Promise<Array>} Array of API keys
 */
export const getApiKeys = async () => {
  const response = await request('/api/api-keys');
  return response;
};

/**
 * Get a specific API key by ID
 * @param {string} id - The API key ID
 * @returns {Promise<Object>} API key details
 */
export const getApiKey = async (id) => {
  const response = await request(`/api/api-keys/${id}`);
  return response;
};

/**
 * Create a new API key
 * @param {string} name - A descriptive name for the API key
 * @returns {Promise<Object>} The created API key with token
 */
export const createApiKey = async (name) => {
  const response = await request('/api/api-keys', {
    method: 'POST',
    json: { name }
  });
  return response;
};

/**
 * Disable (revoke) an API key
 * @param {string} id - The API key ID
 * @returns {Promise<Object>} Success status
 */
export const disableApiKey = async (id) => {
  const response = await request(`/api/api-keys/${id}/disable`, {
    method: 'PUT'
  });
  return response;
};

/**
 * Delete an API key
 * @param {string} id - The API key ID
 * @returns {Promise<Object>} Success status
 */
export const deleteApiKey = async (id) => {
  const response = await request(`/api/api-keys/${id}`, {
    method: 'DELETE'
  });
  return response;
};